(function () {
  var CONFIG = {
    attributeName: "__hubspotutk",
    storageKey: "hs_hutk_cart_synced_v1",
    maxAgeMs: 24 * 60 * 60 * 1000,
    initialDelayMs: 750,
    retryDelayMs: 1500,
    maxRetries: 3
  };

  function getCookie(name) {
    try {
      var parts = document.cookie ? document.cookie.split("; ") : [];
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].indexOf(name + "=") === 0) {
          return decodeURIComponent(parts[i].substring(name.length + 1));
        }
      }
    } catch (e) {}
    return "";
  }

  function getHubSpotUtk() {
    return getCookie("hubspotutk");
  }

  function getSyncState() {
    try {
      return JSON.parse(localStorage.getItem(CONFIG.storageKey) || "{}");
    } catch (e) {
      return {};
    }
  }

  function setSyncState(hutk) {
    try {
      localStorage.setItem(CONFIG.storageKey, JSON.stringify({
        hutk: hutk,
        syncedAt: Date.now(),
        attributeName: CONFIG.attributeName
      }));
    } catch (e) {}
  }

  function shouldSync(hutk, options) {
    options = options || {};
    if (!hutk) return { sync: false, reason: "missing_hutk" };
    if (options.force) return { sync: true, reason: "forced" };

    var state = getSyncState();
    if (state.hutk !== hutk) return { sync: true, reason: "hutk_changed_or_never_synced" };
    if (state.attributeName !== CONFIG.attributeName) return { sync: true, reason: "attribute_name_changed" };
    if (!state.syncedAt) return { sync: true, reason: "missing_syncedAt" };
    if (Date.now() - state.syncedAt > CONFIG.maxAgeMs) return { sync: true, reason: "stale_sync" };
    return { sync: false, reason: "recently_synced" };
  }

  function updateCartAttribute(hutk, reason) {
    var body = { attributes: {} };
    body.attributes[CONFIG.attributeName] = hutk;

    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) throw new Error("Cart update failed with status " + response.status);
      return response.json().catch(function () { return null; });
    }).then(function (cart) {
      setSyncState(hutk);
      return cart;
    });
  }

  function syncHutkToCart(options) {
    options = options || {};
    var hutk = getHubSpotUtk();
    var decision = shouldSync(hutk, options);

    if (!decision.sync) return Promise.resolve(false);
    return updateCartAttribute(hutk, decision.reason).catch(function () {
      return false;
    });
  }

  function retryUntilHutk(attempt) {
    attempt = attempt || 1;
    var hutk = getHubSpotUtk();

    if (hutk) {
      syncHutkToCart({ force: false });
      return;
    }

    if (attempt >= CONFIG.maxRetries) {
      return;
    }

    setTimeout(function () { retryUntilHutk(attempt + 1); }, CONFIG.retryDelayMs);
  }

  function init() {
    setTimeout(function () { retryUntilHutk(1); }, CONFIG.initialDelayMs);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
